import { Component, input, output } from '@angular/core';
import { GuidanceFormat } from '../guidanceFormats';
import { PopupComponent } from '../../../components/popup/popup.component';
import { IconComponent } from '../../../components/icon/icon.component';

@Component({
  selector: 'app-guidance-item',
  imports: [PopupComponent, IconComponent],
  templateUrl: './guidance-item.component.html',
  styleUrl: './guidance-item.component.css',
})
export class GuidanceItemComponent {
  public item = input<GuidanceFormat>();
  public isActive = input<boolean>(false);
  public format = output<string>();
}
